var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNextLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 64,
    viewBox: "0 0 120 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1026:27228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H120V64H0V0Z",
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1026:27228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1269 16.9341C36.8966 17.5262 33.4385 19.3078 31.0211 22.115C28.6037 24.9224 27.3756 26.2944 29.4203 29.3399C31.465 32.3843 25.43 32.6056 28.58 34.173C32.2277 35.9889 33.139 37.4228 35.675 36.8716C40.1435 35.9023 41.7164 32.3445 40.2814 28.811C38.8443 25.2777 38.6612 25.0997 39.8096 22.9816C40.958 20.8632 39.3334 16.3524 38.1269 16.9341Z",
    fill: "#281617"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.989 25.9684C29.989 25.9684 28.72 31.1069 25.4838 31.3066C23.814 31.4094 22.6592 31.2784 22.6592 31.2784C22.6592 31.2784 32.3461 40.0128 34.296 37.3704C35.2225 36.116 31.467 34.521 32.693 31.3445C35.0135 25.3296 34.798 18.8127 29.989 25.9684Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6308 22.9708C32.7539 23.5542 31.7822 23.8718 30.8213 23.9436C32.9177 28.1169 37.1255 27.4398 37.2656 27.4087C37.4164 27.3741 37.5672 27.343 37.6987 27.0946C37.8322 26.8451 37.8624 26.582 37.8236 26.4543C37.787 26.3276 37.6534 26.2002 37.6944 26.1753C37.7375 26.1509 38.0154 25.985 38.0843 25.9434C38.1533 25.9018 38.1705 25.6836 38.1705 25.6836L37.968 25.4673C38.3278 25.2522 38.3644 25.0613 38.3795 24.959C38.3924 24.8562 38.2524 24.7052 38.1339 24.5798C38.0326 24.4708 38.0434 24.1439 38.0843 24.0248C38.1253 23.9071 38.4894 23.7281 38.5519 23.6143C38.6187 23.5004 38.6725 23.2804 38.6273 23.2336C38.5777 23.1851 38.3989 23.0621 38.052 22.8176C37.7073 22.573 37.2527 21.9413 37.2548 20.8123C37.257 19.6835 36.9877 19.7434 36.7679 19.2339C36.2099 17.9297 35.6195 21.6515 33.6308 22.9708Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8722 55.6961L50.1179 52.9391C50.1179 52.9391 54.9829 51.6418 55.9546 56.1826C57.0901 61.4753 59.5226 85.0493 59.5226 85.0493L59.6842 86.1845L67.1455 90.239H55.793L56.6032 86.671L49.7926 62.6696C49.7926 62.6696 38.117 66.0751 34.2237 66.0751C30.3325 66.0751 27.4131 64.6156 27.4131 63.9668C27.4131 63.3181 32.1165 55.3718 34.8722 55.6961Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1385 71.4185C20.4964 71.4185 19.4838 71.2718 18.5961 70.4989C17.3163 69.3878 16.7647 67.411 16.95 64.626C17.075 62.7455 17.8161 60.8426 18.5983 58.8261C19.919 55.4351 21.4121 51.592 20.6322 46.5096L22.0843 46.2861C22.9246 51.7583 21.285 55.9722 19.9707 59.3585C19.1951 61.3483 18.5271 63.0683 18.4151 64.7228C18.2664 66.982 18.6564 68.5919 19.5463 69.3777C20.3887 70.1238 21.4444 69.9321 21.4875 69.9239L21.7827 71.3633C21.7547 71.3685 21.5091 71.4185 21.1385 71.4185Z",
    fill: "#367082"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8028 56.5374C21.378 56.5796 25.0236 56.6438 25.6527 56.6518C29.6451 56.7001 33.0816 55.9509 33.2734 54.9676C34.062 50.8825 34.0986 46.6925 33.3768 42.6049C33.2066 41.6226 29.7184 40.8733 25.6419 40.9233C25.002 40.9308 21.2789 40.9957 20.6929 41.0387C21.9447 46.1334 21.9813 51.4412 20.8028 56.5374Z",
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2552 41.0382C19.8092 41.0437 19.4967 41.2559 19.5592 41.5121C20.671 46.3034 20.7119 51.274 19.6842 56.066C19.6282 56.3233 19.9363 56.5353 20.3737 56.5404C20.811 56.5465 21.2161 56.3409 21.27 56.0839C22.3128 51.2796 22.2804 46.2978 21.1752 41.4944C21.1148 41.2368 20.7033 41.0325 20.2552 41.0382Z",
    fill: "#367082"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0759 56.5296C20.1944 56.5675 20.9852 56.5968 21.1231 56.5997C21.9935 56.6102 22.8898 55.8423 23.0622 54.876C23.7861 50.8519 23.7689 46.7255 23.0061 42.701C22.8252 41.7338 21.9073 40.9676 21.0196 40.9776C20.8796 40.9803 20.0738 41.0105 19.9531 41.0486C21.2071 46.1366 21.248 51.4401 20.0759 56.5296Z",
    fill: "#7DC2F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4524 53.0348L44.1538 43.54C44.1538 43.54 46.3881 43.785 45.3389 45.2137C44.2896 46.6422 37.354 55.0269 37.354 55.0269C37.354 55.0269 30.2741 58.2409 32.4524 53.0348Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7794 31.0059C32.7794 31.0059 37.4009 31.7356 38.0085 33.5601C38.6182 35.3846 38.3748 36.4793 38.3748 37.3306C38.3748 38.1821 32.5359 34.2899 32.7794 31.0059Z",
    fill: "#89A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7923 30.3975L32.7802 31.0055C32.7802 31.0055 38.3756 36.8437 39.5907 37.087C40.8081 37.3302 39.1684 50.6493 39.4701 52.4529C39.6317 53.4259 35.092 53.8719 32.6573 54.2369C30.2248 54.6016 26.8206 54.2369 26.8206 54.2369C26.8206 54.2369 28.0358 50.3447 27.1847 46.3309C26.3337 42.3172 22.5632 39.2762 23.4143 36.4789C24.2653 33.6815 21.8328 33.6815 27.7923 30.3975Z",
    fill: "#9FC400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2641 33.6816C24.2641 33.6816 25.6021 37.4521 25.3587 39.8846C25.1152 42.3173 24.387 48.277 24.387 48.277C24.387 48.277 22.9262 55.21 20.1295 54.3585C17.3329 53.507 17.5742 45.6013 19.5219 40.6143C21.4675 35.6276 23.4131 32.4653 24.2641 33.6816Z",
    fill: "#89A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.728 51.9449C18.728 51.9449 18.8508 53.3436 18.8508 53.6476C18.8508 53.9517 20.1888 54.3166 21.5871 54.3166C22.9855 54.3166 33.3231 48.3567 34.2969 47.9311C35.2708 47.5054 37.5202 46.8972 38.0674 46.8364C38.6147 46.7757 39.0413 45.2552 38.7375 44.2822C38.535 43.6384 38.3346 43.0743 38.0265 42.8897C37.8714 42.7953 37.6861 42.8003 37.4598 42.9442C36.7898 43.3699 34.1138 45.6809 34.1138 45.6809C34.1138 45.6809 27.8505 46.8364 25.3576 47.9311C22.8648 49.0257 19.9454 50.3637 18.728 51.9449Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2292 43.3091L38.0254 42.8896L38.7364 44.2821L38.3098 46.4106L40.0744 46.7147C40.0744 46.7147 40.3157 46.4106 40.0119 46.2891C39.7081 46.1674 39.2837 45.9849 39.2837 45.9849C39.2837 45.9849 40.1347 45.8634 40.4988 45.8026C40.863 45.7416 40.9254 45.6201 40.9254 45.4376C40.9254 45.2551 40.5592 45.1336 40.5592 45.1336C40.5592 45.1336 41.2292 44.8904 41.2896 44.7079C41.3499 44.5254 41.4727 44.2821 41.3499 44.0997C41.2292 43.9174 41.4102 43.4309 41.2292 43.3091Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8204 54.2368H32.6571L49.6308 50.5068C49.6308 50.5068 56.4414 48.7229 54.6574 53.5881C52.8734 58.4533 46.7674 85.0495 46.7674 85.0495L43.0378 84.7252C43.0378 84.7252 43.6863 67.0483 45.4703 63.9671C47.2543 60.8858 47.4159 59.9128 47.4159 59.9128C47.4159 59.9128 35.5765 66.2375 30.7115 65.9131C25.8465 65.5888 21.7916 61.8588 26.8204 54.2368Z",
    fill: "#3B47BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3071 54.678C28.305 54.6802 27.9301 55.3349 27.5552 56.2278C27.1803 57.1213 26.8032 58.2503 26.8032 59.2149C26.8032 59.6729 26.8894 60.0972 27.1113 60.4382C27.3311 60.7797 27.6887 61.0301 28.2037 61.1376C28.3437 61.1671 28.5118 61.1803 28.7036 61.1805C29.783 61.1794 31.7006 60.7595 33.9866 60.1319C40.8402 58.2483 50.9581 54.4852 50.9602 54.4847L50.9279 54.399L50.8504 54.3505C50.8417 54.3634 45.7613 62.4853 42.9474 84.714L43.1284 84.7368C44.5332 73.6334 46.5046 66.0578 48.1248 61.2598C48.9328 58.8609 49.6546 57.1562 50.1738 56.052C50.4324 55.5 50.6414 55.0981 50.7836 54.8346C50.8568 54.7028 50.9107 54.6056 50.9495 54.5416C50.9861 54.4776 51.0055 54.4477 51.0055 54.4477L51.1477 54.2197L50.8956 54.3135C50.8956 54.3137 50.6155 54.4177 50.1156 54.6007C48.3661 55.2406 43.932 56.841 39.4742 58.2809C37.2443 59.0009 35.01 59.6807 33.1032 60.1801C31.1964 60.6798 29.6106 60.9982 28.7036 60.9976C28.5204 60.9976 28.3653 60.9844 28.2425 60.9588C27.7642 60.8573 27.4582 60.638 27.2643 60.3387C27.0682 60.039 26.9864 59.651 26.9864 59.2149C26.9864 58.297 27.3526 57.1803 27.7254 56.2987C27.9107 55.8574 28.096 55.4746 28.2339 55.202C28.3028 55.0658 28.361 54.9572 28.4019 54.8829C28.4429 54.8086 28.4644 54.7689 28.4644 54.7687L28.3071 54.678Z",
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2627 44.7652L40.252 44.7446L40.2627 44.0967H67.0892V44.7652L67.0203 44.8859C66.6756 45.4478 66.0572 45.5486 65.3483 45.5486H42.0036C41.2948 45.5486 40.6764 45.4478 40.3317 44.8859L40.2627 44.7652Z",
    fill: "#D0DEE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7283 44.8746V44.8925L46.6615 44.9905C46.5537 45.1351 46.4223 45.2424 46.2693 45.3201H42.1886C41.5077 45.3201 40.9131 45.2387 40.5813 44.7847L40.5166 44.6858L40.5059 44.6695L40.5123 44.3506H46.7283V44.8746Z",
    fill: "#B6C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3477 44.7051H63.7534V44.2471H50.3477V44.7051Z",
    fill: "#B6C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.877 44.0732L50.3544 30.8912C50.4471 30.5423 50.8026 30.2607 51.1494 30.2607H69.9718C70.3186 30.2607 70.5255 30.5423 70.435 30.8912L66.9575 44.0732H46.877Z",
    fill: "#D7DFE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5205 37.1674C57.3416 37.8396 57.7446 38.3856 58.4168 38.3856C59.0912 38.3856 59.7785 37.8396 59.9573 37.1674C60.134 36.4932 59.7332 35.9473 59.0588 35.9473C58.3866 35.9473 57.6971 36.4932 57.5205 37.1674Z",
    fill: "#B6C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9038 90.8325H92.6509L88.1198 46.9561H84.1382L89.9038 90.8325Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4028 48.9783L86.1502 62.2662L88.2207 47.9461L88.1195 46.9561H84.6398L84.4028 48.9783Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3039 90.8325H69.0488L64.5178 46.9561H60.5361L66.3039 90.8325Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8037 48.9783L62.5489 62.2662L64.6216 47.9461L64.5182 46.9561H61.0386L60.8037 48.9783Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4739 90.8325H34.729L39.2579 46.9561H43.2395L37.4739 90.8325Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9747 48.9783L37.6465 62.5191L39.1568 47.9461L39.2581 46.9561H42.7399L42.9747 48.9783Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4165 48.0952H68.5214V45.5312H35.4165V48.0952Z",
    fill: "#387BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9897 48.0952H91.3924V45.5312H66.9897V48.0952Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.556 17.1125C38.4225 16.5439 31.6894 14.7411 28.2831 16.5361C22.5627 19.5506 23.4611 23.5494 23.8619 24.1743C27.6927 30.1375 22.1533 30.7603 20.393 31.9889C18.4087 33.3753 20.3026 37.3163 22.8277 37.828C27.2704 38.729 31.7691 32.7128 31.5839 28.9981C31.3792 24.8732 32.3897 23.4428 35.1518 21.8017C37.3452 20.4986 38.8318 18.2867 38.556 17.1125Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6341 14.0491C79.6341 17.7315 76.6479 20.7168 72.9657 20.7168H49.2504C45.5683 20.7168 42.582 17.7315 42.582 14.0491V9.07442C42.582 5.39183 45.5683 2.40625 49.2504 2.40625H72.9657C76.6479 2.40625 79.6341 5.39183 79.6341 9.07442V14.0491Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5776 24.3306V17.5049H59.0044L51.5776 24.3306Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8804 9.44466H70.6208V8.43848H51.8804V9.44466Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8804 12.1214H70.6208V11.1152H51.8804V12.1214Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8804 14.7984H70.6208V13.792H51.8804V14.7984Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9814 23.3697C27.9814 24.2962 28.7334 25.047 29.6598 25.047C30.5842 25.047 31.3361 24.2962 31.3361 23.3697C31.3361 22.4433 30.5842 21.6924 29.6598 21.6924C28.7334 21.6924 27.9814 22.4433 27.9814 23.3697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2002 26.4336C36.4375 26.6652 35.5606 26.8041 34.688 26.8039C33.5611 26.8044 32.4407 26.5727 31.5595 26.0272C30.6805 25.4802 30.0341 24.6313 29.8251 23.3435C29.629 22.1287 29.5407 21.0644 29.5407 20.1362C29.5407 17.9153 30.0384 16.4767 30.7257 15.6004C31.4152 14.7248 32.2921 14.3945 33.1108 14.393C33.7292 14.3925 34.3088 14.586 34.7267 14.8808C34.9357 15.0279 35.1038 15.1996 35.218 15.3813C35.3322 15.5631 35.3904 15.7532 35.3904 15.9453H35.7286C35.7286 15.6818 35.6446 15.4289 35.5024 15.2029C35.2891 14.8633 34.9465 14.5796 34.5328 14.3777C34.117 14.1762 33.6258 14.0569 33.1108 14.0566C32.2016 14.0551 31.2105 14.4356 30.4629 15.3931C29.7131 16.35 29.2046 17.8672 29.2046 20.1362C29.2046 21.0855 29.2951 22.1671 29.4912 23.3969C29.7109 24.7735 30.4305 25.7254 31.3829 26.3131C32.3373 26.9026 33.5159 27.1398 34.688 27.1403C35.5972 27.14 36.5021 26.9965 37.2993 26.7554L37.2002 26.4336Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1617 26.8752L37.8081 26.7095C37.9999 26.6601 38.1184 26.4626 38.0688 26.2702C38.0193 26.078 37.821 25.961 37.6293 26.0103L36.9829 26.1758C36.7912 26.2251 36.6727 26.4229 36.7222 26.6151C36.7718 26.8075 36.97 26.9245 37.1617 26.8752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4556 23.37C28.4556 24.0349 28.9942 24.574 29.66 24.574C30.3236 24.574 30.8622 24.0349 30.8622 23.37C30.8622 22.7051 30.3236 22.166 29.66 22.166C28.9942 22.166 28.4556 22.7051 28.4556 23.37Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9838 28.4268H69.4528C71.1097 28.4268 72.4649 27.0716 72.4649 25.4152C72.4649 23.7588 71.1097 22.4033 69.4528 22.4033H58.9838C57.3291 22.4033 55.9717 23.7588 55.9717 25.4152C55.9717 27.0716 57.3291 28.4268 58.9838 28.4268Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8087 28.1656L55.9717 25.373V30.9581L60.8087 28.1656Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2371 25.2663C62.2371 25.7386 61.8536 26.1214 61.3817 26.1214C60.9099 26.1214 60.5264 25.7386 60.5264 25.2663C60.5264 24.794 60.9099 24.4111 61.3817 24.4111C61.8536 24.4111 62.2371 24.794 62.2371 25.2663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0745 25.2663C65.0745 25.7386 64.691 26.1214 64.2191 26.1214C63.7473 26.1214 63.3638 25.7386 63.3638 25.2663C63.3638 24.794 63.7473 24.4111 64.2191 24.4111C64.691 24.4111 65.0745 24.794 65.0745 25.2663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9099 25.2663C67.9099 25.7386 67.5264 26.1214 67.0546 26.1214C66.5827 26.1214 66.1992 25.7386 66.1992 25.2663C66.1992 24.794 66.5827 24.4111 67.0546 24.4111C67.5264 24.4111 67.9099 24.794 67.9099 25.2663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7638 45.5665H71.8985C71.4783 45.5665 71.1357 45.2246 71.1357 44.8029V39.2754H76.5286V44.8029C76.5286 45.2246 76.1861 45.5665 75.7638 45.5665Z",
    fill: "#D4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3181 43.896V43.7281H70.5403C70.4024 43.7281 70.2774 43.6721 70.1848 43.5803C70.0943 43.4883 70.0383 43.3634 70.0383 43.225V40.6999C70.0383 40.5618 70.0943 40.4368 70.1848 40.3448C70.2774 40.253 70.4024 40.1968 70.5403 40.1968H71.3181C71.456 40.1968 71.5809 40.253 71.6736 40.3448C71.7662 40.4368 71.8222 40.5618 71.8222 40.6999V43.225C71.8222 43.3634 71.7662 43.4883 71.6736 43.5803C71.5809 43.6721 71.456 43.7281 71.3181 43.7281V44.0636C71.7813 44.0629 72.1562 43.6874 72.1562 43.225V40.6999C72.1562 40.2377 71.7813 39.862 71.3181 39.8613H70.5403C70.0792 39.862 69.7021 40.2377 69.7021 40.6999V43.225C69.7021 43.6874 70.0792 44.0629 70.5403 44.0636H71.3181V43.896Z",
    fill: "#D4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9144 31.3448C96.9144 32.1065 96.296 32.7246 95.5333 32.7246H83.5776C82.8149 32.7246 82.1987 32.1065 82.1987 31.3448V13.8698C82.1987 13.1082 82.8149 12.4902 83.5776 12.4902H91.8555L96.9144 17.5485V31.3448Z",
    fill: "#E9F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3149 17.0889L96.9149 21.6277V17.5484L96.4539 17.0889H92.3149Z",
    fill: "#D4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8555 12.4902V16.1687C91.8555 16.931 92.4738 17.5485 93.2344 17.5485H96.9144L91.8555 12.4902Z",
    fill: "#9FC400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5322 19.9032H93.2324V19.3848H84.5322V19.9032Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5322 22.5809H93.2324V22.0625H84.5322V22.5809Z",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5322 25.2576H89.8562V24.7393H84.5322V25.2576Z",
    fill: "#7EB3FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNextLesson);
export default __webpack_public_path__ + "static/media/img_next_lesson.662c0dd63b63de7a869b8157134bfe9f.svg";
export { ForwardRef as ReactComponent };